module.exports = __webpack_public_path__ + "img/collection_doll.5788b10d.png";